"use strict";
/* eslint-disable import/export */
/* eslint-disable @typescript-eslint/no-namespace */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edge = void 0;
var Edge;
(function (Edge) {
    Edge["None"] = "None";
    Edge["Left"] = "Left";
    Edge["Right"] = "Right";
    Edge["Top"] = "Top";
    Edge["Bottom"] = "Bottom";
    Edge["TopLeft"] = "TopLeft";
    Edge["TopRight"] = "TopRight";
    Edge["BottomLeft"] = "BottomLeft";
    Edge["BottomRight"] = "BottomRight";
})(Edge = exports.Edge || (exports.Edge = {}));
(function (Edge) {
    // ---------------------------------------------------------------------------
    function isTop(e) {
        return e === Edge.Top || e === Edge.TopLeft || e === Edge.TopRight;
    }
    Edge.isTop = isTop;
    // ---------------------------------------------------------------------------
    function isBottom(e) {
        return e === Edge.Bottom || e === Edge.BottomLeft || e === Edge.BottomRight;
    }
    Edge.isBottom = isBottom;
    // ---------------------------------------------------------------------------
    function isLeft(e) {
        return e === Edge.Left || e === Edge.TopLeft || e === Edge.BottomLeft;
    }
    Edge.isLeft = isLeft;
    // ---------------------------------------------------------------------------
    function isRight(e) {
        return e === Edge.Right || e === Edge.TopRight || e === Edge.BottomRight;
    }
    Edge.isRight = isRight;
})(Edge = exports.Edge || (exports.Edge = {}));
//# sourceMappingURL=edge.js.map